import {
  LAT_LNG,
  LOCATE_AMBULANCE,
  LOCATE_AMBULANCE_BY_LOCATION,
  LOCATE_TRAUMACENTER_BY_LOCATION,
  LOCATE_POLICESTATION_BY_LOCATION,
  LOCATE_POI_BY_LOCATION,
} from "../actions/types";

const initialState = {
  ambulance: [],
  ambulanceByLocation: [],
  traumaCenterByLocation: [],
  clickLatLng: [],
  policeStationByLocation: [],
  poiByLocation: [],
};

const ambulanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOCATE_AMBULANCE:
      return {
        ...state,
        ambulance: payload,
      };
    default:
      return state;
  }
};
const ambulanceReducerLocation = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOCATE_AMBULANCE_BY_LOCATION:
      return {
        ...state,
        ambulanceByLocation: payload,
      };

    default:
      return state;
  }
};
const traumaCenterReducerLocation = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOCATE_TRAUMACENTER_BY_LOCATION:
      return {
        ...state,
        traumaCenterByLocation: payload,
      };

    default:
      return state;
  }
};
const poiReducerLocation = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOCATE_POI_BY_LOCATION:
      return {
        ...state,
        poiByLocation: payload,
      };

    default:
      return state;
  }
};
const policeStationReducerLocation = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOCATE_POLICESTATION_BY_LOCATION:
      return {
        ...state,
        policeStationByLocation: payload,
      };

    default:
      return state;
  }
};
const onClickLatLngReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case LAT_LNG:
      return {
        ...state,
        clickLatLng: payload,
      };
    default:
      return state;
  }
};

export {
  ambulanceReducer,
  ambulanceReducerLocation,
  traumaCenterReducerLocation,
  onClickLatLngReducer,
  policeStationReducerLocation,
  poiReducerLocation,
};
